<template>
  <div :class="{ 'container': needContainer }">
    <div class="scrolling-wrapper">
      <div v-for="item in items" :key="item.id" class="card" :class="is_new(item.date) ? 'has-badge':null">
        <router-link :to="base_dir + getMeta(item, 'slug') + (from ? '?ref=' + from : '')">
          <span v-if="is_new(getMeta(item, 'first_published_at'))" class="ribbon">NEW</span>
          <img v-if="shape == 'square'" :src="baseUrl + getImage(item, 'square')" :alt="getValue(item, 'title')">
          <img v-if="shape == 'rectangle'" :src="baseUrl + getImage(item, 'thumb')" :alt="getValue(item, 'title')">
          <img v-if="shape == 'wide'" :src="baseUrl + getImage(item, 'wide')" :alt="getValue(item, 'title')">
          <h3 class="tour-title" :class="{ 'home' : total }" v-if="shape == 'rectangle' || shape == 'wide'">{{ getValue(item, 'title') }}</h3>
          <p v-if="getValue(item, 'preview')" class="tex-preview">
            {{ getValue(item, 'preview_text') }}
          </p>
          <div v-if="shape == 'rectangle' || shape == 'wide'" :class="'duration ' + lang"><span class="icon-access_time"></span>{{ $t("time_title") }}{{ getValue(item, 'duration') }}{{ $t("time_unit") }}</div>
        </router-link>
      </div>
      <div v-if="more > 3" class="card more">
        <router-link :to="moreLink">MORE<span>+{{more}} {{moreText}}</span></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data(){
    return{
      baseUrl: process.env.VUE_APP_BASE_URL,
      lang: this.$root.$i18n.locale,
      moreText: null,
      moreLink: null,
    }
  },

  computed: {
    more: function () {
      // `this` は vm インスタンスを指します
      return this.total - this.items.length
    },
    needContainer: function () {
      let type = null
      const length = this.items.length
      if(this.noContainer){
        return false
      }
      if(length > 0){
        type = this.items[0].type
      }
      if(type == 'spot' && length > 6){
        return false
      }
      if(type == 'tour' && length > 3){
        return false
      }

      return true
    }
  },

  props: {
    items: {
      type: Array,
      default: function() {
        return []
      }
    },
    base_dir: {
      type: String,
      default: () => '/spots/'
    },
    shape: {
      type: String,
      default: () => ''
    },
    from: {
      type: String,
      default: () => ''
    },
    image_src: {
      type: String,
      default: () => 'src'
    },
    total: {
      type: [String, Number],
      default: () => 0
    },
    noContainer: {
      type: Boolean,
      default: () => false
    },
  },

  methods:{
    is_new: function(pubdate) {
      // moment.locale('ja')
      const cd = moment().startOf('day').hour(12)
      const pd = moment(pubdate);
      return cd.diff(pd, 'days') < 30
    },
    getBaseSlug: function(type) {
      let base = '/'
      if (type == 'spot') {
        base = '/spots/'
      } else if (type == 'tour') {
        base = '/tours/'
      }
      return base
    },
    getValue: function(item, key){
      let value = ''
      if(Object.prototype.hasOwnProperty.call(item, "value")){
        value = item['value'][key]
      } else {
        value = item[key]
      }
      return value
    },
    getMeta: function(item, key){
      const meta = this.getValue(item, 'meta')
      return this.getValue(meta, key)
    },
    getImage: function(item, key){
      const image = this.getValue(item, key)
      return this.getValue(image, this.image_src)
    },
  },

  created(){
    if(this.items[0].type == 'spot'){
      this.moreText = 'Spots'
      this.moreLink = '/spots/'
    }else if(this.items[0].type == 'tour'){
      this.moreText = 'Tours'
      this.moreLink = '/tours/'
    }
  },

  mounted() {
    // console.log(this.items)
  }
}
</script>
<style lang="sass"></style>
